import Button from '@mui/material/Button'
import { styled } from '@mui/material/styles'
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip'
import { Box } from '@mui/system'
import PropTypes from 'prop-types'
import * as React from 'react'
import AppInfoIcon from './AppInfoIcon'


const CustomTooltip = styled(({ className, ...props }) => (
	<Tooltip {...props} arrow classes={{ popper: className }} />
))(() => ({
	[`& .${tooltipClasses.arrow}`]: {
		color: '#25262A'
	},
	[`& .${tooltipClasses.tooltip}`]: {
		backgroundColor: '#25262A',
		padding: '12px 16px'
	}
}))

AppTooltip.propTypes = {
	buttonText: PropTypes.string,
	icon: PropTypes.string,
	isButton: PropTypes.string,
	onFunc: PropTypes.string,
	placement: PropTypes.string,
	sxElement: PropTypes.object,
	title: PropTypes.string
}


export default function AppTooltip({title, placement, sxElement, isButton, onFunc, buttonText}) {
	const onClickTooltipBtn = (e) => {
		onFunc(e)
	}
	return (

		<CustomTooltip title={title} placement={placement}>
			{isButton ?
				<Button
					onClick={onClickTooltipBtn}
					sx={sxElement}
				>{buttonText}
				</Button> :
				<Box sx={{position: 'relative'}}>
					<Box sx={sxElement}>
						<AppInfoIcon />
					</Box>
				</Box>
			}
		</CustomTooltip>

	)
}
